module.exports = __webpack_public_path__ + "img/logohor.9085d7a9.webp";